module.exports = __webpack_public_path__ + "../resources/images/illustration_sent-973ea54e06df3239d3ef13ae0b38a3de.svg";